import { SoundByte } from "../enum/sounds";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import { clamp01, lerp, PlaySound } from "../util";
import Color from "../util/Color";

export default class Explosion extends MonoBehavior {

    radius = 0;
    size: number = 64;
    radius2 = 0;
    maxLifeTime = 3;
    done = false;
    w = 100;
    color: Color = new Color(255, 255, 80);

    Update(): void {

        this.radius = lerp(this.radius, this.size, Time.deltaTime * 16);
        // this.radius2 = dMath.Lerp(this.radius, this.size**2, Time.deltaTime);
        this.radius2 += this.size/16;

        if (this.timeAlive >= this.maxLifeTime) {
            this.engine.RemoveGameObject(this.gameObject);
        }

        this.w = lerp(this.w, 1, Time.deltaTime * 4);
    }

    Draw(): void {
        const t = clamp01(this.timeAlive/this.maxLifeTime);
        const alpha = 1 - t;
        // const color = Color.lerp([255, 255, 230], this.color, t);
        this.ctx.strokeStyle = this.color.toHexWithAlpha(alpha);
        this.ctx.lineWidth = this.w;
        this.engine.StrokeCircle(this.transform.position, this.radius);
        this.ctx.lineWidth = 1;
        this.engine.StrokeCircle(this.transform.position, this.radius2);
    }

}